<template lang="pug">
.contratos
    .head.row.ac.col-s
        h1(style="margin-right: 12px") Contratos
        Button(:layout="show ? 'red-go' : 'green-go'" @click="show = !show" title="NOVO CONTRATO") {{ show ? "x" : "+" }}
        .new(v-if="show") 
            ContratoForm(:reload="load")
    .row.ac.jc.g12(v-if="loader" style="margin-top: 30px")
        Loader
    .list(v-else)
        .head.row.g12
            .g3 Nome
            .g3 Status
            .g3 Operação
        .line(v-for="c,i in list")
            .item.row.ac(@click="list[i].s=!c.s;list=[...list]")
                .g3 {{c.nome}}
                .g3 {{c.status}}
                .g3 {{c.operacao}}
            .form(v-if="c.s")
                ContratoForm(:f="c" :reload="load")
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";
import ContratoForm from "@/views/admin/components/ContratoForm.vue";
export default {
    name: "Contratos",
    components: {
        Button,
        Loader,
        ContratoForm
    },
    data() {
        return {
            loader: true,
            show: false,
            list: []
        };
    },
    methods: {
        ...mapActions("admin", ["CONTRATO_LISTA"]),
        async load() {
            this.loader = true
            this.CONTRATO_LISTA().then(({ data }) => { if (data) this.list = data })
            this.loader = false
        }
    },
    mounted() {
        this.load()
    }
};
</script>


<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.contratos
    @include page
    .new
        flex: 1
    .line
        &:nth-child(even)
            background: #ddd
        .item
            border-radius: 6px
            padding: 10px
            cursor: pointer
            
            &:hover
                background: $purple
                color: white
        .form
            padding: 20px
            background: #eee
            margin-bottom: 30px
            border-radius: 20px
            @include border

</style>